import { useEffect, useState } from 'react';
import { DEFAULT_PAGE_SIZE } from '@constants/pagination';
import { useUrlParamGraphQl } from './useUrlParamGraphQl';

export const usePaginatedGraphQl = (query, update, modifyUrlParams) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const {
    loading,
    fetchError,
    fetchData,
    setQueryVariables,
    setUpdateVariables,
    updating,
    updateError,
    updateResponse,
  } = useUrlParamGraphQl(query, update, modifyUrlParams);

  useEffect(() => {
    setQueryVariables({ page: currentPage, limit: pageSize });
  }, [currentPage, pageSize, setQueryVariables]);

  return {
    loading,
    updating,
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
    setUpdateVariables,
    fetchError,
    fetchData,
    updateError,
    updateResponse,
  };
};
